// Un-comment while debugging in local

// import createLogger from 'redux-logger';
//
// const logger = createLogger({
//    level: 'info'
// });
//
// export default [
//    logger
// ];
export default [];
